import { ReactNode } from 'react';
import { useController } from 'react-hook-form';
import { useFieldStateError } from './useFieldStateError';
import { FormControl } from '@mui/material';
import { Switch, SwitchHelperText, SwitchLabel } from './Switch';

export function SwitchField({
  name,
  label,
  defaultValue,
  required,
  disabled,
  helperText,
}: {
  name: string;
  label: ReactNode;
  defaultValue?: string;
  required?: boolean;
  disabled?: boolean;
  helperText?: ReactNode;
}) {
  const { field, fieldState } = useController({
    name,
    disabled,
    defaultValue,
    rules: {
      required,
    },
  });

  const fieldError = useFieldStateError(label, fieldState.error);

  return (
    <FormControl component="fieldset" variant="standard">
      <SwitchLabel
        control={
          <Switch
            name={name}
            checked={field.value}
            onChange={field.onChange}
            onBlur={field.onBlur}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        }
        label={label}
      />
      {helperText ? <SwitchHelperText>{helperText}</SwitchHelperText> : null}
      {fieldError ? <SwitchHelperText error>{fieldError}</SwitchHelperText> : null}
    </FormControl>
  );
}
